// extracted by mini-css-extract-plugin
module.exports = {"overalladd":"InterviewModalpopup_overalladd__C9q0K","scoreinputfield":"InterviewModalpopup_scoreinputfield__CVi9m"};